import React, { useState, useRef } from "react"
import { formatDate, formatDateDB, formatDateTime } from "../../components/DateUtil";
import { Modal } from 'bootstrap';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { base64ToBlob } from "../../components/DataConvert";
import { saveAs } from 'file-saver';

export default function BankFileStatusList({ data, searchSubmit, hasUpdatePermission }) {

    /* handle import bank file */
    const [selectedFile, setSelectedFile] = useState(null)
    const [selectedFileData, setSelectedFileData] = useState(null)
    const [selectedFilename, setSelectedFilename] = useState(null)
    const [selectedBank, setSelectedBank] = useState({ id: '', fileId: '', bankName: '', genDateFrom: '', genDateTo: '' })
    const [errorMessageClass, setErrorMessageClass] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [orderSuccessRow, setOrderSuccessRow] = useState(0)
    const [orderFailedRow, setOrderFailedRow] = useState(0)
    const importBankFileRef = useRef()
    const [isUploadCompleted, setIsUploadCompleted] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    let navigate = useNavigate()

    // export part
    const [exportErrorMessageClass, setExportErrorMessageClass] = useState('')
    const [exportErrorMessage, setExportErrorMessage] = useState('')
    const [isExportLoading, setIsExportLoading] = useState(false)
    const [genDateFrom, setGenDateFrom] = useState(null);
    const [genDateTo, setGenDateTo] = useState(null);


    function importFileHandle(id, fileId, bankName, dateFrom, dateTo) {
        console.log('selected bank: ', id, fileId, bankName, dateFrom, dateTo)
        let item = { id: id, fileId: fileId, bankName: bankName, genDateFrom: dateFrom, genDateTo: dateTo }
        setSelectedBank(item)
        setSelectedFile(null)
        setSelectedFileData(null)
        setSelectedFilename(null)
        setErrorMessage('')
        setIsUploadCompleted(false)
        setOrderSuccessRow(0)
        setOrderFailedRow(0)
        importBankFileRef.current.value = ''
        let importBankFileForm = new Modal('#importBankFileForm')
        importBankFileForm.show()
    }

    // On file select (from the pop up)
    const onFileChange = (event) => {
        const file = event.target.files[0]
        setSelectedFile(file)
        setErrorMessage('')

        if (file) {
            setSelectedFilename(file.name);
            const reader = new FileReader();

            reader.onload = (e) => {
                let base64 = e.target.result.split(',')
                setSelectedFileData(base64[1]); // The Base64 string
            };

            reader.onerror = (error) => {
                console.error("Error reading file:", error)
                setSelectedFile(null)
                setSelectedFileData(null)
                setSelectedFilename(null)
                setErrorMessage('Read file error')
            };

            reader.readAsDataURL(file); // Start reading the file as Base64'
        } else {
            setSelectedFile(null)
            setSelectedFileData(null)
            setSelectedFilename(null)
            setErrorMessage('No file')
        }

    }
    // On file upload (click the upload button)
    async function onFileUpload() {
        setIsUploadCompleted(false)
        setIsLoading(true)
        setErrorMessageClass('text-danger')
        setErrorMessage('')
        setOrderSuccessRow(0)
        setOrderFailedRow(0)

        // check user has selected file
        if (!selectedFile) {
            setIsLoading(false)
            setErrorMessage('No Bank file is selected!')
            return
        }

        // Create an object of formData
        /*
        const formData = new FormData();

        // Update the formData object
        formData.append('id', selectedBank.id)
        formData.append('fileId', selectedBank.fileId)
        formData.append('user', localStorage.getItem('name'))
        formData.append('filename', selectedFilename)
        formData.append('fileData', selectedFileData)
        // formData.append(
        //     "file",
        //     selectedFile,
        //     selectedFile.name
        // );
        */
        const formData = {
            id: selectedBank.id,
            fileId: selectedBank.fileId,
            user: localStorage.getItem('name'),
            filename: selectedFilename,
            fileData: selectedFileData
        }


        // Details of the uploaded file
        //console.log(selectedFile);
        console.log('Selected file: ' + selectedFilename)
        //console.log('Selected file data: ' + selectedFileData)
        //console.log(formData)

        // Request made to the backend api
        // Send formData object
        let token = localStorage.getItem('token')
        try {
            axios.post(process.env.REACT_APP_BASE_URL + "autorenew/v1/upload_bankfile", formData, {
                timeout: 900000, // 15 mins for this specific request,
                headers: {
                    'Authorization': 'Bearer ' + token
                    //'Content-Type': 'multipart/form-data'
                }
            // }).then(response => {
            //     console.log('response status: ' + JSON.stringify(response.data))
            //     if (response.data.status === 'success') {
            //         setErrorMessageClass('text-success')
            //         setOrderSuccessRow(response.data.orderSuccess)
            //         setOrderFailedRow(response.data.orderFailed)
            //     }
            //     console.log('orderSuccessRow: ' + orderSuccessRow + ', orderFailedRow: ' + orderFailedRow)

            //     setErrorMessage(response.data.message)
            //     setIsUploadCompleted(true)
            }).catch(error => {
                console.log('get upload bank file failed: ' + error.message)
                // if (error.response.status === 401 || error.response.status === 403) {
                //     console.log('no authorize, redirect to login page')
                //     navigate(process.env.REACT_APP_LOGIN_URI)
                // } else {
                //     console.log('get upload bank file failed: ' + error.message)
                //     setErrorMessage(error.message)
                // }
                setIsUploadCompleted(true)
            })

            // process after call api
            setErrorMessageClass('text-success')
            setErrorMessage('The system is importing data. You can close the window and view the import results in the log.')
            setIsUploadCompleted(true)
        } catch (err) {
            console.log('get upload bank file failed: ' + err.message)
            setErrorMessage(err.message)
            setIsUploadCompleted(true)
        }

        //await new Promise( res => setTimeout(res, 1000) );
        setIsLoading(false)
    }

    /* open export window to confirm */
    async function exportConfirmHandle(id, fileId, bankName, dateFrom, dateTo) {
        console.log('selected bank: ', id, fileId, bankName, dateFrom, dateTo)
        let item = { id: id, fileId: fileId, bankName: bankName, genDateFrom: dateFrom, genDateTo: dateTo }
        setSelectedBank(item)
        setGenDateFrom(new Date(dateFrom))
        if (!dateTo) {
            dateTo = dateFrom
        }
        setGenDateTo(new Date(dateTo))
        setExportErrorMessage('')
        let exportBankFileForm = new Modal('#exportBankFileForm')
        exportBankFileForm.show()
    }
    /* handle export bank file */
    async function exportFileHandle() {
        console.log('export bank file: ', selectedBank.id, selectedBank.fileId, selectedBank.bankName, selectedBank.genDateFrom, selectedBank.genDateTo)
        //alert('export bank file id: ' + id + ', fileId: ' + fileId)
        setIsExportLoading(true)
        setExportErrorMessageClass('text-danger')
        setExportErrorMessage('')

        const formData = {
            id: selectedBank.id,
            fileId: selectedBank.fileId,
            genDateFrom: formatDateDB(genDateFrom),
            genDateTo: formatDateDB(genDateTo),
            user: localStorage.getItem('name')
        }
        // Send formData object
        let token = localStorage.getItem('token')
        try {
            axios.post(process.env.REACT_APP_BASE_URL + "autorenew/v1/export_bankfile", formData, {
                timeout: 900000, // 15 mins for this specific request,
                headers: {
                    'Authorization': 'Bearer ' + token,
                },
                responseType: 'json'
                //responseType: 'blob'
            // }).then(response => {
            //     //console.log(JSON.stringify(response))
            //     setExportErrorMessageClass('text-success')
            //     setExportErrorMessage(response.data.message)
            }).catch(error => {
                console.log('get download bank file failed: ' + error.message)
                // if (error.response.status === 401 || error.response.status === 403) {
                //     console.log('no authorize, redirect to login page')
                //     navigate(process.env.REACT_APP_LOGIN_URI)
                // } else {
                //     console.log('get download bank file failed: ' + error.message)
                //     setExportErrorMessage('Failed to export file')
                // }
            })

            // process after call api
            setExportErrorMessageClass('text-success')
            setExportErrorMessage('The system is exporting data and will display the file name when the operation is complete.')
        } catch (err) {
            console.log('get download bank file failed: ' + err.message)
            setExportErrorMessage('Failed to export file')
        }

        //await new Promise( res => setTimeout(res, 1000) );
        setIsExportLoading(false)
    }
    /* handle download bank file */
    async function downloadFileHandle(item) {
        console.log('download bank file: ', item.id, item.fileid, item.bank, item.exportfile)

        const formData = {
            id: item.id,
            fileId: item.fileid,
            user: localStorage.getItem('name')
        }
        // Send formData object
        let token = localStorage.getItem('token')
        try {
            await axios.post(process.env.REACT_APP_BASE_URL + "autorenew/v1/download_bankfile", formData, {
                timeout: 900000, // 15 mins for this specific request,
                headers: {
                    'Authorization': 'Bearer ' + token,
                },
                responseType: 'json'
                //responseType: 'blob'
            }).then(response => {
                //console.log(JSON.stringify(response))
                console.log(response.headers["content-disposition"])
                let fileName = response.headers["content-disposition"].split("filename=")[1];
                console.log('receive bank file: ' + fileName)

                const blob = base64ToBlob(response.data, "application/octet-stream");
                let url = window.URL.createObjectURL(blob);
                saveAs(url, fileName);

                /*
                // create file link in browser's memory
                const href = URL.createObjectURL(response.data);
    
                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
    
                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
                */

                // close modal
                //let exportBankFileForm = new Modal('#exportBankFileForm')
                //exportBankFileForm.hide()
            }).catch(error => {
                if (error.response.status === 401 || error.response.status === 403) {
                    console.log('no authorize, redirect to login page')
                    navigate(process.env.REACT_APP_LOGIN_URI)
                } else {
                    console.log('get download bank file failed: ' + error.message)
                    alert(error.message)
                }
            })
        } catch (err) {
            console.log('get download bank file failed: ' + err.message)
            alert(err.message)
        }
    }

    // display log of file id when export or import file
    const [exportImportLogList, setExportImportLogList] = useState(null)
    async function handleImportExportLog(id, fileId, bankName) {
        let item = { id: id, fileId: fileId, bankName: bankName }
        setSelectedBank(item)

        console.log('find history log of file id: ' + fileId)
        const formData = {
            fileId: fileId,
        }
        let token = localStorage.getItem('token')
        await axios.post(process.env.REACT_APP_BASE_URL + 'autorenew/v1/bankfile_status_log', formData, {
            timeout: 300000, // 5 mins for this specific request,
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('display import/export log file')
                setExportImportLogList(response.data.data)
            } else {
                console.log('get order_state_all failed: ' + response.data.message)
            }

        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get order_state_all failed: ' + err.message)
            }
        })

        let exportImportFileHistoryModal = new Modal('#exportImportFileHistoryModal')
        exportImportFileHistoryModal.show()
    }

    return (
        <>
            <div className="table-responsive table-hover table-sales">
                <table className="table table-striped table-hover align-items-center mb-0">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col">No.</th>
                            <th scope="col">File ID</th>
                            <th scope="col">Bank</th>
                            <th scope="col">Gen Date</th>
                            <th scope="col">Gen By</th>
                            <th scope="col" className="text-end">Rec. Num</th>
                            <th scope="col" className="text-end">Amount</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                            <th scope="col">Exported By</th>
                            <th scope="col">Action</th>
                            <th scope="col">Imported By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data?.map((order, index) => {
                                let statusClass = ''
                                let action = order.action.toLowerCase()
                                let showExportButton = false
                                if (action === 'attention') statusClass = 'badge text-bg-warning'
                                else if (action === 'import') {
                                    showExportButton = true
                                    statusClass = 'badge text-bg-success'
                                } else if (action === 'export') {
                                    showExportButton = true
                                    statusClass = 'badge text-bg-primary'
                                }
                                //console.log('file: -' + order.exportfile + '-')
                                let exportfile = ''
                                let displayFilename = ''
                                if (order.exportfile !== null && order.exportfile.length > 0) {
                                    let ary = order.exportfile.split('/')
                                    if (ary.length > 0) {
                                        exportfile = ary[ary.length - 1]
                                        if (exportfile.length > 10) {
                                            displayFilename = exportfile.substring(0, 9) + '...'
                                        } else {
                                            displayFilename = exportfile
                                        }
                                    }
                                }

                                return (
                                    <tr key={order.id}>
                                        <td>{index + 1}</td>
                                        <td>{order.fileid}
                                            <button type="button" title="Log" className="btn btn-link link-black link-offset-2 link-underline link-underline-opacity-0" onClick={handleImportExportLog.bind(this, order.id, order.fileid, order.bank)}>
                                                <i className="bi bi-journal-text"></i>
                                            </button>
                                        </td>
                                        <td>{order.bank}</td>
                                        <td>{formatDate(new Date(order.gendatefrom))} - {formatDate(new Date(order.gendateto))}</td>
                                        <td>{order.genby}</td>
                                        <td className="text-end">{order.recnum}</td>
                                        <td className="text-end">{
                                            new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'code' })
                                                .format(order.amount).replace("USD", "").trim()}</td>
                                        <td>{order.status}</td>
                                        <td>{hasUpdatePermission &&
                                            <button type="button" onClick={exportConfirmHandle.bind(this, order.id, order.fileid, order.bank, order.gendatefrom, order.gendateto)} className="btn btn-primary" style={{ "--bs-btn-font-size": ".75rem", "--bs-btn-padding-y": ".15rem", "width": "80px" }} title="Export file from system">
                                                Export
                                                <i className="bi bi-arrow-up-right-circle ms-2"></i>
                                            </button>
                                        }
                                            {exportfile !== '' && <><br/><br/><a href="#" onClick={downloadFileHandle.bind(this, order)} title={exportfile}>{displayFilename}</a></>}
                                        </td>
                                        <td>{order.exportedby}<br />{formatDateTime(new Date(order.lastexport))}</td>
                                        <td>{hasUpdatePermission &&
                                            <button type="button" onClick={importFileHandle.bind(this, order.id, order.fileid, order.bank, order.gendatefrom, order.gendateto)} className="btn btn-success" style={{ "--bs-btn-font-size": ".75rem", "--bs-btn-padding-y": ".15rem", "width": "80px" }} title="Import file to system">
                                                <i className="bi bi-arrow-down-right-circle me-2"></i>
                                                Import
                                            </button>
                                        }
                                        </td>
                                        <td>{order.importedby}<br />{formatDateTime(new Date(order.lastimport))}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>

            <div className="modal fade" id="importBankFileForm" tabIndex="-1" aria-labelledby="importBankFileLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="importBankFileLabel">Import File: {selectedBank.bankName}</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-2 row">
                                    <label htmlFor="staticOrderFileId" className="col-sm-3 col-form-label">File Id :</label>
                                    <div className="col-sm-9">
                                        <input type="text" readOnly className="form-control-plaintext" id="staticOrderFileId" value={selectedBank.fileId} />
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label htmlFor="staticOrderId" className="col-sm-3 col-form-label">Gen Date :</label>
                                    <div className="col-sm-9 col-form-label">
                                        {formatDate(new Date(selectedBank.genDateFrom))} - {formatDate(new Date(selectedBank.genDateTo))}
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <label htmlFor="formFile" className="form-label">Bank file to import</label>
                                    <input ref={importBankFileRef} className="form-control" type="file" id="importBankFile" onChange={onFileChange.bind(this)} />
                                </div>
                                {selectedFile &&
                                    <div className="p-2 bg-body-secondary rounded">
                                        <div className="row">
                                            <label htmlFor="staticSelectedFileType" className="col-sm-3 col-form-label">Type :</label>
                                            <div className="col-sm-9">
                                                <input type="text" readOnly className="form-control-plaintext" id="staticSelectedFileType" value={selectedFile.type} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <label htmlFor="staticSelectedFileLastModified" className="col-sm-3 col-form-label">Last modified :</label>
                                            <div className="col-sm-9">
                                                <input type="text" readOnly className="form-control-plaintext" id="staticSelectedFileLastModified" value={formatDateTime(selectedFile.lastModifiedDate)} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <label htmlFor="staticSelectedFileSize" className="col-sm-3 col-form-label">Size :</label>
                                            <div className="col-sm-9">
                                                <input type="text" readOnly className="form-control-plaintext" id="staticSelectedFileSize" value={selectedFile.size < 1000 ? selectedFile.size : Math.round(selectedFile.size / 1000) + "KB"} />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </form>
                            <div className="mb-3">
                                <p className="mt-4 mb-6 text-sm">
                                    <span className={errorMessageClass}>{errorMessage}</span>
                                    {/* <><br /><span className="text-success">Success: {orderSuccessRow}</span> <span className="ms-2 text-danger">Failed: {orderFailedRow}</span></> */}
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal" onClick={() => { searchSubmit(1) }}>Close</button>
                            {isLoading ?
                                <button className="btn btn-primary" style={{ width: '120px' }} type="button">
                                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span role="status" className="ms-3">Upload</span>
                                </button>
                                : !isUploadCompleted &&
                                <button type="button" className="btn btn-primary" style={{ width: '120px' }} onClick={onFileUpload.bind(this)}>
                                    <i className="bi bi-upload me-2"></i> Upload
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="exportBankFileForm" tabIndex="-1" aria-labelledby="exportBankFileLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exportBankFileLabel">Export File: {selectedBank.bankName}</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-2 row">
                                    <div>
                                        <label htmlFor="staticOrderId" className="col-form-label">From Date :</label>
                                    </div>
                                    <div className="input-group">
                                        <DatePicker className="form-control" selected={genDateFrom} onChange={(date) => setGenDateFrom(date)} dateFormat="dd/MM/yyyy" />
                                        <span className="input-group-text"><i className="bi bi-calendar-date"></i></span>
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <div>
                                        <label htmlFor="staticOrderFileId" className="col-form-label">To Date :</label>
                                    </div>
                                    <div className="input-group">
                                        <DatePicker className="form-control" selected={genDateTo} onChange={(date) => setGenDateTo(date)} dateFormat="dd/MM/yyyy" />
                                        <span className="input-group-text"><i className="bi bi-calendar-date"></i></span>
                                    </div>
                                </div>
                            </form>
                            <div className="mb-3">
                                <p className="mt-4 mb-6 text-sm">
                                    <span className={exportErrorMessageClass}>{exportErrorMessage}</span>
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal" onClick={() => { searchSubmit(1) }}>Close</button>
                            {isExportLoading ?
                                <button className="btn btn-primary" style={{ width: '120px' }} type="button">
                                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span role="status" className="ms-3">Export</span>
                                </button>
                                :
                                <button type="button" className="btn btn-primary" style={{ width: '120px' }} onClick={exportFileHandle.bind(this)}>
                                    <i className="bi bi-upload me-2"></i> Export
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/* export, import file history */}
            <div className='row'>
                <div className='col-md-12'>
                    <div className="modal fade" id="exportImportFileHistoryModal" tabIndex="-1" >
                        <div className="modal-dialog modal-lg modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5><span>Bank: {selectedBank.bankName}</span>  <span className="ms-3">File Id: {selectedBank.fileId}</span></h5>
                                </div>

                                <div className="modal-body">
                                    <div className="table-responsive table-hover table-sales">
                                        <table id="basic-datatables" className="table table-striped table-hover align-items-center mb-0">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th scope="col">No.</th>
                                                    <th scope="col">Gen Date</th>
                                                    <th scope="col">Action</th>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">By</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    exportImportLogList?.map((log, index) => {
                                                        return (
                                                            <>
                                                                <tr key={log.id}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{formatDate(new Date(log.gendatefrom))} - {formatDate(new Date(log.gendateto))}</td>
                                                                    <td>{log.action}</td>
                                                                    <td>{log.status}</td>
                                                                    <td>{log.actionby}<br />{formatDateTime(new Date(log.actiondate))}</td>
                                                                </tr>
                                                                <tr key={index + 1}>
                                                                    <td colSpan="5">Remark: {log.remark}</td>
                                                                </tr>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}